<template>
    <el-checkbox-group
        v-model="itemSelectedCityIds"
        @change="onChangeSelected"
    >
        <el-checkbox
            v-for="item in allOptionCityList"
            :key="item.value"
            :disabled="disabled || existedIds.includes(item.value)"
            :label="item.value"
        >
            {{ item.label }}
        </el-checkbox>
    </el-checkbox-group>
</template>

<script>
// 整体逻辑：一个城市无法被用在多个 item，每个 item 下的城市都是互斥的。
/**
 * 全量城市列表：allCityList
 * 全部已选中的城市 itemSelectedCityIds = (用户新选择的 selectedIds) + (已存在的城市：existedIds 需要被禁用 disabled)
 * 可选择的城市：publicIds
 */

export default {
    props: {
        existedIds: { // 草稿中对应的已存在城市 id 列表，只是初始化一次，进入之后就不再被修改，在视图中表现为 disabled。
            type: Array,
            default: () => [],
        },
        publicIds: { // 本类型（比如配方单、保质期等）下，公共可追加选择的列表
            type: Array,
            default: () => [],
        },
        selectedIds: { // 本次 新提报的城市
            type: Array,
            default: () => [],
        },
        uuid: {
            type: String,
            required: true,
        },
        allCityList: {
            type: Array,
            default: () => [], // {label: '', value: ''}
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // 展示的所有列表项的集合：被勾选的：草稿中本来已经存在的 + 本local次操作新增的；未被勾选的：public 的
            itemSelectedCityIds: [], // 绑定到 select 上的  model，包含所有 被勾选的列表：即包含初始的 existedIds，又包含后续用户交互新增的
        };
    },
    computed: {
        allOptionCityList() { // 即 itemSelectedCityIds + publicIds
            // 顺序和 原始 city 列表保持一致
            const targetList = [...new Set([...this.itemSelectedCityIds, ...this.publicIds])].map((id) => +id);
            return this.allCityList.filter((item) => targetList.includes(item.value));
        },
        // 是否存在有效的城市，如果不存在，需要将这个item清理
        hasEffectiveIds() {
            return [...(this.publicIds || []), ...(this.existedIds || []), ...(this.selectedIds || [])].length > 0;
        },
    },
    watch: {
        existedIds(newVal) {
            this.itemSelectedCityIds = [...newVal, ...this.selectedIds];
        },
        selectedIds(newVal) {
            this.itemSelectedCityIds = [...newVal, ...this.existedIds];
        },
        // 当子组件已选择城市变化，需要通知父组件，来更新公共可选择的城市
        itemSelectedCityIds() {
            this.$emit('selected-ids-change');
        },
    },
    created() {
        if (this.existedIds && this.selectedIds) {
            this.itemSelectedCityIds = [...this.existedIds, ...this.selectedIds];
        }
    },
    methods: {
        onChangeSelected(val) {
            this.$emit('update:selected:city', { uuid: this.uuid, selectCityIds: [...new Set(val)].filter((id) => !this.existedIds.includes(id)) });
        },
    },
};
</script>
